import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Grid } from '@mui/material';

const Pagina_404 = () => {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>404 - Página no encontrada | Carolina Gómez</title>
            </Helmet>
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
                <Typography variant="h1">404</Typography>
                <Typography>Página no encontrada</Typography>
                <Button onClick={() => navigate('/')}>Volver al inicio</Button>
            </Grid>
        </>
    );
};

export default Pagina_404;